import React, { useMemo, useState } from "react";
import { Money } from "../../../components";
import { Icon, IconButton } from "../../../components/ui";
import RemovePriceConfirm from "./RemovePriceConfirm";
import axios from "axios";
import PriceItem from "./PriceItem";
import { monthLabels, boxLabels } from "../../constants";
import { sourceOptions } from "../../constants";
import CollapseButton from "./CollapseButton";
import { conditionLabels } from "../../constants";
import { useAllFx } from "../../../hooks/fx";

const ucFirst = (string) => {
  return string ? string[0].toUpperCase() + string.substring(1) : string;
};

const convertString = (string) => {
  let arr;
  try {
    arr = JSON.parse(string);
  } catch (_) {
    return undefined; // missing/blank/non-JSON — render nothing
  }
  if (arr && arr.length > 0) {
    return arr.map((item) => conditionLabels[item] || item).join(", ");
  }
};

const UnapprovedPriceItemRenderer = ({ item, onItemRemoved }) => {
  const [isRemoving, setIsRemoving] = useState(false);
  const year = item?.year_month?.substr(0, 4);
  const month = item?.year_month?.substr(5, 2);
  const monthLabel = monthLabels?.[month];
  const locationName = item?.region?.replace("-e", " E").replace("uk", "UK");
  const price = parseInt(item?.gbp_price / 100) * 100;
  const trateMedian = item?.trade_median;
  const removeItem = async (id) => {
    try {
      await axios.delete(`/api/unapproved-product-prices/${id}/delete`);
      onItemRemoved();
    } catch (error) {
      // Reported to the console rather than swallowed. The confirm modal is
      // driven by `isRemoving`, so closing it moved to `finally`: a failed
      // delete used to leave it open with no message and no way to tell.
      console.error("Failed to remove unapproved price", error);
    } finally {
      setIsRemoving(false);
    }
  };

  return (
    <>
      <tr
        key={item.id}
        className="price-list"
        style={{
          backgroundColor: `${item.under_priced ? "#A4E6A0" : ""}`,
        }}
      >
        <td>{item?.price_date?.substr(0, 10)}&nbsp;</td>
        <td>WhatsApp</td>
        <td>{year}&nbsp;</td>
        <td>{convertString(item?.condition)}&nbsp;</td>
        <td>
          {/* gbp_price pivot / GBP trade median — explicit GBP. */}
          <Money amount={price} currency="gbp" style={{ fontSize: "14px" }} />
          &nbsp;
        </td>
        <td>
          <Money amount={trateMedian} currency="gbp" style={{ fontSize: "14px" }} />
          &nbsp;
        </td>
        <td>{item?.match_confidence}&nbsp;</td>
        <td>{boxLabels?.[item?.delivery_set]}&nbsp;</td>
        <td>{item?.group_name}&nbsp;</td>
        <td>{item?.sender_name}&nbsp;</td>
        <td>{item?.sender_phone}&nbsp;</td>
        <td>{ucFirst(locationName)}&nbsp;</td>
        <td>
          <IconButton
            variant="ghost"
            size="sm"
            label="Remove price"
            data-btn="price-delete"
            onClick={() => setIsRemoving(true)}
          >
            <Icon name="Trash2" size="sm" />
          </IconButton>
        </td>
      </tr>
      <RemovePriceConfirm
        inlineRow
        isOpen={isRemoving}
        onCancel={() => setIsRemoving(false)}
        onRemove={() => removeItem(item.id)}
      />
    </>
  );
};

export default UnapprovedPriceItemRenderer;
